import { render, staticRenderFns } from "./ITable.vue?vue&type=template&id=57e71a2d&scoped=true&"
import script from "./ITable.vue?vue&type=script&lang=js&"
export * from "./ITable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e71a2d",
  null
  
)

export default component.exports